module.exports = __webpack_public_path__ + "img/11-1.b9615397.png";